module.exports = __webpack_public_path__ + "img/analytics-marketing-team-1.ada807c2.svg";